var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errors
    ? _c(
        "div",
        { staticClass: "has-error" },
        _vm._l(_vm.errors, function(error) {
          return _c("div", [
            _vm._v("\n        " + _vm._s(error.error) + "\n    ")
          ])
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cccd80ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cccd80ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./www/js/Components/ValidationMessage/ValidationMessage.vue
// module id = 534
// module chunks = 0